import Home from "./../src/pages/home/home";
require('./../src/pages/home/item/nav.scss')

export default Home